import { InterestReason } from "Services/API/API";
import React from "react";
import ModalBodyBook from "./ModalBodyBook";
import ModalBodyDemo from "./ModalBodyDemo";
import ModalBodyGeneric from "./ModalBodyGeneric";
import ModalBodyList from "./ModalBodyList";

interface ModalBodySuccessProps {
   interestReason: InterestReason;
   toggle(): void;
}

const ModalBodySuccess: React.FC<ModalBodySuccessProps> = ({ interestReason, toggle }) => {
   let result;
   switch (parseInt(interestReason.toString())) {
      case InterestReason.Book:
         result = <ModalBodyBook toggle={toggle} />
         break;
      case InterestReason.Demo:
         result = <ModalBodyDemo toggle={toggle} />
         break;
      case InterestReason.List:
         result = <ModalBodyList toggle={toggle} />
         break;
      default:
         result = <ModalBodyGeneric toggle={toggle} />
         break;
   }

   return result;
}

export default ModalBodySuccess;